import {
    UPDATE_TAB_INDEX,
    FETCH_ALL_PLANS_SUCCESS,
    FETCH_ALL_PLANS_ERROR,
    FETCH_ALL_PLANS_START,
} from "../reducers/plansContextReducer";

const updateTabIndex = key => ({
    type: UPDATE_TAB_INDEX,
    payload: key,
});

const fetchAllPlansStart = () => ({
    type: FETCH_ALL_PLANS_START,
});
const fetchAllPlansSuccess = allPlans => ({
    type: FETCH_ALL_PLANS_SUCCESS,
    payload: allPlans,
});
const fetchAllPlansError = error => ({
    type: FETCH_ALL_PLANS_ERROR,
    payload: error,
});

export { updateTabIndex, fetchAllPlansStart, fetchAllPlansSuccess, fetchAllPlansError };
